/**
 * Win celebration — a CSS-only burst behind the prize.
 *
 * No library, no canvas, no dependency. It renders NOTHING when the phone asks
 * for reduced motion, and it is purely decorative (aria-hidden), so it can
 * never swallow a tap on the result underneath.
 */
const PIECES = Array.from({ length: 14 }, (_, i) => i);

export const GoalCelebrate = ({ accent = '#ffffff', button = '#E01B2E' }) => (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true"
         data-testid="goal-celebrate">
        <style>{`
            @keyframes gg-burst {
                0%   { transform: translate(0,0) scale(0.4); opacity: 0; }
                18%  { opacity: 1; }
                100% { transform: translate(var(--dx), var(--dy)) scale(1); opacity: 0; }
            }
            @keyframes gg-glow {
                0%, 100% { opacity: 0.35; transform: scale(1); }
                50%      { opacity: 0.7;  transform: scale(1.06); }
            }
            .gg-piece { animation: gg-burst 1400ms ease-out forwards; }
            .gg-glow  { animation: gg-glow 2600ms ease-in-out infinite; }
            @media (prefers-reduced-motion: reduce) {
                .gg-piece { display: none; }
                .gg-glow  { animation: none; opacity: 0.4; }
            }
        `}</style>
        <div className="gg-glow absolute left-1/2 top-1/2 h-44 w-44 -translate-x-1/2 -translate-y-1/2 rounded-full blur-2xl"
             style={{ backgroundColor: button }} />
        {PIECES.map((i) => {
            const angle = (i / PIECES.length) * Math.PI * 2;
            return (
                <span
                    key={i}
                    className="gg-piece absolute left-1/2 top-1/2 block h-2 w-2 rounded-sm"
                    style={{
                        backgroundColor: i % 2 ? accent : button,
                        '--dx': `${Math.cos(angle) * 120}px`,
                        '--dy': `${Math.sin(angle) * 120}px`,
                        animationDelay: `${(i % 5) * 70}ms`,
                    }}
                />
            );
        })}
    </div>
);

export default GoalCelebrate;
